module.exports = __webpack_public_path__ + "static/img/logo.25c5ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tazg/logo.png
// module id = S4LM
// module chunks = 23